(() => {
  const activateTab = (tabs, selectedTab, focus = false) => {
    tabs.forEach((tab) => {
      const selected = tab === selectedTab;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      if (panel) panel.hidden = !selected;
    });

    if (focus) selectedTab.focus();
  };

  const initialize = (root) => {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    if (tabs.length === 0) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tabs, tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        activateTab(tabs, tabs[nextIndex], true);
      });
    });
  };

  const initializeLinkedSelect = (root) => {
    root.querySelectorAll('[data-fineps-linked-select]').forEach((select) => {
      if (select.dataset.finepsInitialized === 'true') return;
      select.dataset.finepsInitialized = 'true';
      select.addEventListener('change', () => {
        if (select.value) window.location.assign(select.value);
      });
    });
  };

  const applyInlineDifferenceFilter = (table, checked) => {
    table.querySelectorAll('tbody tr').forEach((row) => {
      const values = Array.from(row.querySelectorAll('td'))
        .map((cell) => cell.textContent.trim().toLowerCase());
      const allEqual = values.length > 1 && values.every((value) => value === values[0]);
      row.hidden = Boolean(checked && allEqual);
    });
  };

  const initializeDifferenceControls = (root) => {
    root.querySelectorAll('[data-fineps-compare-differences]').forEach((control) => {
      if (control.dataset.finepsInitialized === 'true') return;
      const section = control.closest('.fineps-comparison');
      const table = section && section.querySelector('.fineps-comparison__table');
      if (!table) return;
      control.dataset.finepsInitialized = 'true';
      control.addEventListener('change', () => applyInlineDifferenceFilter(table, control.checked));
    });
  };

  document.querySelectorAll('[data-fineps-tabs]').forEach(initialize);
  initializeLinkedSelect(document);
  initializeDifferenceControls(document);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-fineps-tabs]').forEach(initialize);
    initializeLinkedSelect(event.target);
    initializeDifferenceControls(event.target);
  });
})();
